export enum CouponType {
  PriceDiscount = '01',
  FreeProduct = '02',
  Other = '99',
}
